module.exports = __webpack_public_path__ + "img/dashboard-blank-golfer.a8bed16b.png";